import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';

export const slugToFileName = (slug) => {
    if (!slug) return null;
    
    return slug
        .split('-')
        .map((word) => {
            if (/^[0-9]+$/.test(word)) {
                return word;
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join('') + '.js';
};

const BlogWrapper = () => {
    // Use React Router's useParams to get the blog ID
    const { blogId } = useParams();

    const BlogComponent = useMemo(() => {
        if (!blogId) return null;

        const context = require.context('../../blogs/', false, /\.js$/);
        const fileName = slugToFileName(blogId);

        if (!fileName) return null;

        try {
            // Find the matching file in the context
            const path = context.keys().find(path =>
                path === `./${fileName}` ||
                path.toLowerCase() === `./${fileName.toLowerCase()}`
            );

            if (!path) {
                return null;
            }

            const module = context(path);
            return module.default;
        } catch (error) {
            console.error('Blog loading error:', error);
            return null;
        }
    }, [blogId]);

    if (!blogId || !BlogComponent) {
        return <NotFound />;
    }

    return <BlogComponent />;
};

export default BlogWrapper;